const initializeAccordion = (triggers) => {
	triggers?.forEach((trigger) => {
	  trigger.addEventListener("click", (e) => {
		const parent = trigger.parentElement;
  
		if (parent.classList.contains("accordion-open")) {
		  parent.classList.remove("accordion-open");
		} else {
		  parent.classList.add("accordion-open");
		}
		e.stopPropagation();
	  });
	});
  };
  
  const closeAccordionOnClickOutside = (accordion) => {
	document.addEventListener("click", (e) => {
	  if (!accordion.contains(e.target)) {
		accordion.classList.remove("accordion-open");
	  }
	});
  };
  
  const accordionHandler = () => {
	const triggers = document.querySelectorAll(".accordion-single__trigger");
	initializeAccordion(triggers);
  };
  
  const postSecondaryNavigationHandler = () => {
	const triggers = document.querySelectorAll(
	  ".post__secondary-navigation-accordion-trigger"
	);
	initializeAccordion(triggers);

	triggers?.forEach((trigger) => {
	  const parent = trigger.parentElement;
	  closeAccordionOnClickOutside(parent);
	});
  };
  
  if (document.readyState !== "loading") {
	accordionHandler();
	postSecondaryNavigationHandler();
  } else {
	document.addEventListener("DOMContentLoaded", () => {
	  accordionHandler();
	  postSecondaryNavigationHandler();
	});
  }